import React from 'react';
import configs from 'config';

import theme from './Footer.scss';

const Info = () => {
  return process.env.NODE_ENV === 'production' ? null : (
    <span className={ theme.devInfo }> { ' ~> ' } { configs.product_name } { ' - ' } <b> { configs.api_server }</b> </span>
  );
};

export default Info;
